'use client'

import { PartnerHospitalDoctor } from '@/entities/hospital/api/types'
import { useMemo, useState } from 'react'
import { DoctorProfile } from '../../molecules'
import { Typography } from '@/shared/ui/atoms'
import SummaryCard from '../../molecules/SummaryCard'
import { CustomButton } from '@/shared/ui/molecules'
import { getDoctorPositionLabel } from "@/widgets/hospital/lib/doctorPosition"
import Link from "next/link"
import { useParams } from "next/navigation"
import { useTranslations } from "next-intl"

interface DotorsProps {
  doctors: PartnerHospitalDoctor[]
  hospitalOriginId: number
  /**
   * 새 상세 페이지의 섹션 셸 안에 들어갈 때. 제목과 바깥 여백은 섹션이 갖고 있으므로
   * 여기서는 내용만 그린다. 기본값(false)은 기존 상세 페이지의 모습 그대로다.
   */
  embedded?: boolean
}

const Dotors = ({ doctors, hospitalOriginId, embedded = false }: DotorsProps) => {
  const t = useTranslations()
  const [isMore, setIsMore] = useState(false)
  const params = useParams()
  const locale = (params as { locale?: string })?.locale

  const isShowMoreButton = doctors.length > 3
  const list = useMemo(() => (isMore ? doctors : doctors.slice(0, 3)), [doctors, isMore])

  return (
    <div id={embedded ? undefined : "hospital-doctor"} className={embedded ? "" : "px-4 pb-2"}>
      {embedded ? null : (
        <Typography size={18} className="pt-3 pb-1 text-gray-900 font-bold">
          {t("partnerTabs.doctor")} <span className="text-primary-600 font-semibold">{doctors.length}</span>
        </Typography>
      )}
      <div className="flex flex-col">
        {list.map((doctor) => (
          <Link
            key={doctor.doctorId}
            href={
              locale
                ? `/${locale}/doctor/${doctor.doctorId}?hospitalId=${hospitalOriginId}`
                : `/doctor/${doctor.doctorId}?hospitalId=${hospitalOriginId}`
            }
            className="block"
          >
            <SummaryCard
              thumbnail={doctor.profileImageUrl}
              title={`${doctor.name} ${getDoctorPositionLabel(doctor.positionCode)}`}
              className="border-b border-gray-100 last:border-b-0"
            >
              <DoctorProfile doctor={doctor} />
            </SummaryCard>
          </Link>
        ))}
      </div>

      {isShowMoreButton && (
        <CustomButton className="mt-2 mb-4 py-2 w-full bg-gray-100 rounded-lg" onClick={() => setIsMore((v) => !v)}>
          <Typography size={14} lineHeight={20} className="text-gray-900 font-medium">
            {isMore ? t("common.collapse") : t("doctors.viewAll")}
          </Typography>
        </CustomButton>
      )}
    </div>
  )
}

export default Dotors
